import { LanguageEnum } from './../common/enum';

export class Language {
  constructor(public id: string = '', public name = 'English', public isoCode = LanguageEnum.English) {}
}
